<template>
  <section>
    <div class="ProgramsMethod">
      <div class="ProgramsMethod__wrapper">
        <CleanMethodLogo class="ProgramsMethod__logo" />
        <BaseImage
          v-if="image"
          :id="image"
          class="ProgramsMethod__image"
        />
      </div>
      <CourtFull
        :orientation="orientation"
        :expand="orientation === 'horizontal'"
        sidelines
        class="ProgramsMethod__court"
      />
      <div
        class="ProgramsMethod__copy"
        v-html="splitCopy[0]"
      />
    </div>
    <div
      v-if="splitCopy[1]"
      class="ProgramsMethod__copy-2"
      v-html="splitCopy[1]"
    />
  </section>
</template>

<script>
  import CourtFull from './CourtFull';
  import CleanMethodLogo from './CleanMethodLogo';

  export default {
    components: {
      CourtFull,
      CleanMethodLogo,
    },
    props: {
      image: {
        type: [Number, Boolean],
        required: true,
      },
      copy: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        innerWidth: window.innerWidth,
      };
    },
    computed: {
      headingId() {
        return this._uid;
      },
      orientation() {
        return this.innerWidth < 768 ? 'vertical' : 'horizontal';
      },
      splitCopy() {
        const [first, ...rest] = this.copy.match(/<p>.*?<\/p>/g);

        return [
          first,
          rest.join(''),
        ];
      },
    },
    created() {
      window.addEventListener('resize', () => {
        this.innerWidth = window.innerWidth;
      });
    },
  };
</script>

<style lang="scss">
  .ProgramsMethod {
    position: relative;
    // display: flex;
    // flex-direction: column;

    @include breakpoint(tablet) {
      display: flex;
      // flex-direction: row;
    }
  }

  .ProgramsMethod__copy {
    position: relative;
    // width: 50%;
    padding:
      spacing(base-delta)
      (spacing(base-gamma) / 2) + spacing(base-delta)
      (spacing(base-gamma) / 2) + spacing(base-delta);
    color: color(bronze);
    line-height: line-height(copy);

    @include breakpoint(tablet) {
      width: 50%;
      padding: (spacing(base-delta) / 2) + spacing(base-epsilon);
    }

    @include breakpoint(laptop) {
      padding: (spacing(base-delta) / 2) + spacing(base-zeta);
    }
  }

  .ProgramsMethod__copy-2 {
    position: relative;
    margin-right: auto;
    margin-left: auto;
    padding: (spacing(base-gamma) / 2) + spacing(base-delta);
    color: color(bronze);
    line-height: line-height(copy);

    @include breakpoint(tablet) {
      margin-top: spacing(base-delta);
      width: 80%;
    }
  }

  .ProgramsMethod__court {
    position: absolute;
    top: 0;
    padding: spacing(base-gamma) / 2;
    width: 100%;
    height: 100%;
    color: color(bronze);
    pointer-events: none;

    @include breakpoint(tablet) {
      padding: spacing(base-delta) / 2;
    }
  }

  .ProgramsMethod__image {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: color(slate);
    object-fit: cover;
  }

  .ProgramsMethod__wrapper {
    position: relative;
    padding-top: percentage(9 / 16);

    @include breakpoint(tablet) {
      padding-top: 0;
      width: 50%;
    }
  }

  .ProgramsMethod__logo {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 1;
    width: 60%;
    fill: color(white);
    transform: translate(-50%, -50%);
  }
</style>
